import React from 'react'
import { render } from 'react-dom'
import App from './App'
import './app.css'

render(<App />, document.getElementById('root'))
